<template>
  <div class="area-wrap">
    <el-select
      v-model="selectedCountryId"
      @change="onChangeCountry"
      class="area-select"
      filterable
      :placeholder="$t(`editPersonal.国家/地区`)"
    >
      <el-option
        v-for="item in option_country"
        :key="`${item.id}_${item.name}`"
        :value="item.id"
        :label="item.id === 45 ? item.name : item.nameEn "
      >
      </el-option>
    </el-select>
    <el-select
      v-model="selectedStateId"
      @change="onChangeState"
      class="area-select"
      filterable
      :placeholder="$t(`index.省份`)"
    >
      <el-option
        v-for="item in option_state"
        :key="`${item.id}_${item.name}`"
        :value="item.id"
        :label="item.name"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="selectedCityId"
      @change="onChangeCity"
      class="area-select"
      filterable
      :placeholder="$t(`index.城市`)"
    >
      <el-option
        v-for="item in option_city"
        :key="`${item.id}_${item.name}`"
        :value="item.id"
        :label="item.name"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getCountries, getStates, getCities } from "@service/api";
import { isCN, lang } from "@utils/lang";
export default {
  //父组件传入的area值，onAreaChange用于将修改后的值传递给父组件
  model: {
    prop: "area",
    event: "onAreaChange",
  },
  props: ["area"],
  data() {
    return {
      lang,
      isCN,
      option_country: [],
      option_state: [],
      option_city: [],
      select: {
        country: {},
        state: {},
        city: {},
      },
      //没直接用select.country.id，而是单独再创建id变量，是因为el-option 会出现错误
      selectedCountryId:"",
      selectedStateId:"",
      selectedCityId:"",
    };
  },
  //在语言不变的情况下，在组件挂载时获取国家列表
  mounted() {this.getCountries();},
  watch: {
    "lang.value": function (val) {
      if (val) {
        this.getCountries();
      }
    },
    //监听area变化，如果父组件area值变化，这里会更新
    area: async function (val = []) {
      const [
        { id: countryId } = {},
        { id: stateId } = {},
        { id: cityId } = {},
      ] = val;

      if (!countryId) return;
      
      if (countryId !== this.select.country.id) {
        await this.getCountries(countryId);
      }
      if (!stateId) return;
      if (stateId !== this.select.state.id) {
        await this.getStates(countryId, stateId);
      }
      if (!cityId) return;
      if (cityId !== this.select.city.id) {
        await this.getCities(stateId, cityId);
      }
    },
  },
  methods: {
    onChangeCountry(countryId) {
      const country =
        this.option_country.find((item) => item.id === countryId) || {};
      this.select.country = country;
      this.option_state = [];
      this.select.state = {};
      this.option_city = [];
      this.select.city = {};
      this.getStates(countryId);
      this.onAreaChange();
    },
    onChangeState(stateId) {
      const state = this.option_state.find((item) => item.id === stateId) || {};
      this.select.state = state;
      this.option_city = [];
      this.select.city = {};
      this.getCities(stateId);
      this.onAreaChange();
    },
    onChangeCity(cityId) {
      const city = this.option_city.find((item) => item.id === cityId) || {};
      this.select.city = city;
      this.onAreaChange();
    },
    async getCountries(countryId) {
      try {
        const data = (await getCountries()) || [];
        this.option_country = data;
        if (countryId !== undefined) {
          //如果传入了国家id，则选中该国家
          this.selectedCountryId = countryId
          this.onChangeCountry(countryId);
        }

        if (!this.select.country.id && isCN()) {
          // 如果是中文网站，自动选择中国
          

          const chana = data.find((item) => item.id === 45);
          this.select.country = chana;
          this.selectedCountryId = chana.id;
          this.onChangeCountry(chana.id);
        }
        // 如果不是中文，去掉中国，实现国内、国外商城分离
        if(!isCN()){
          this.option_country = data.filter((item) => item.id !== 45);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getStates(countryId, stateId) {
      try {
        const data = await getStates({ countryId });
        this.option_state = data;
        if (stateId !== undefined) {
          const state =
            this.option_state.find((item) => item.id === stateId) || {};
          this.select.state = state;
          this.selectedStateId = state.id;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getCities(stateId, cityId) {
      try {
        const { id: countryId } = this.select.country;
        const data = await getCities({ countryId, stateId });
        this.option_city = data;
        if (cityId !== undefined) {
          const city =
            this.option_city.find((item) => item.id === cityId) || {};
          this.select.city = city;
          this.selectedCityId = city.id;
        }
      } catch (e) {
        console.log(e);
      }
    },
    onAreaChange() {
      const arr = [this.select.country, this.select.state, this.select.city];
      const nameArr = arr.map((item = {}) =>{
        //国外订单地址显示英文，州和城市默认应该是英文，只调整国家
        if(!isCN() && item===this.select.country){
          return item.nameEn;
        }
        return item.name
      }).filter((item) => item);
      let areaName = "";
      if (isCN()) {
        areaName = nameArr.join(" ");
      } else {
        areaName = [...nameArr].reverse().join(" ");
      }
      //这里的onAreaNameChange是父组件传入的event，onAreaChange是父组件传入的v-model对应的event
      this.$emit("onAreaNameChange", areaName);
      this.$emit("onAreaChange", arr);
    },
  },
};
</script>

<style lang="scss" scoped>
.area-wrap {
  display: flex;
  justify-content: space-between;
  .area-select {
    width: 350px;
    margin-right: 10px;
  }
}
</style>